export default "__VITE_ASSET__9cU5m5WK__"